import VisibilityIcon from '@mui/icons-material/Visibility';
import { REDESIGN_NAV_OFFSET_CLASS } from 'root/src/client/v2/layout/helpers/redesignNavbar';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Preview indicator for the drop PREVIEW page (/drop-preview/:slug, the sales proposal share link).
// The page renders an unpublished proposal draft to a prospect via drops.getDropPreview, so this makes
// the "not live yet, shared by link" context explicit. Rendered in normal flow above the hero (not
// sticky) so it never collides with the sticky DropSectionNav (both would otherwise want top-[72px]);
// the outer padding clears the fixed navbar, and because it is always present in preview mode from the
// first paint there is no layout shift.
export const DropPreviewBanner = () => (<div className={cn('px-4 sm:px-6 lg:px-8', REDESIGN_NAV_OFFSET_CLASS)}>
		<div className="mx-auto mt-4 flex max-w-7xl items-start gap-3 rounded-xl border border-solid border-neon-purple/30 bg-neon-purple/10 px-4 py-3 backdrop-blur-md">
			<VisibilityIcon sx={{ fontSize: 20 }} className="mt-0.5 shrink-0 text-neon-purple"/>
			<div className="min-w-0">
				<p className="font-display text-sm font-semibold text-foreground">Preview</p>
				<p className="mt-0.5 text-xs text-muted-foreground">
					This is an unpublished proposal draft. It is not live yet and is only visible to people with this link.
				</p>
			</div>
		</div>
	</div>);
